import { handleCreateProject, handleEditProject, projectsSync } from 'serviceWorker/services/projects';
import { getGdprClause } from 'serviceWorker/services/projects/gdprClause';
import { projectSource } from 'serviceWorker/services/projects/projectSource';
import { channelServer, ChannelUnsubscribe } from 'shared/channels';
import { projectContract } from 'shared/domain/project/projectContract';
import { runWhenRequestsAllowed } from './runWhenRequestsAllowed';
import { serveEntityRequests, syncWithPermissions } from './serveEntityRequests';

/**
 * Answers the project requests: one project for its details view, a download
 * of a missing list, and changes, answered once queued (the outcome follows as
 * an event with their `uniqueId`).
 */
export function serveProjectRequests(): ChannelUnsubscribe {
  const unsubscribes = [
    serveEntityRequests(projectContract, projectSource),
    channelServer.handle(projectContract, {
      getOneById: ({ id }) => projectSource.getOneById(id),
      // Bootstrap and the reload after a data flush: the permissions are pulled along.
      downloadWhenMissing: () =>
        runWhenRequestsAllowed(() => syncWithPermissions(() => void projectsSync.downloadWhenMissing())),
      create: handleCreateProject,
      edit: handleEditProject,
      getGdprClause,
    }),
  ];
  return () => unsubscribes.forEach((unsubscribe) => unsubscribe());
}
